import React from 'react';
import ReactDOM from 'react-dom';
import store from './app/store';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import * as serviceWorker from './serviceWorker';

import { UserManager } from './app/utils';
//routes
import Routes from './app/routes';

import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';

ReactDOM.render((
   <Provider store={store}>
      <OidcProvider store={store} userManager={UserManager}>
        <App />
      </OidcProvider>
  </Provider>

  ), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
